import { isNotDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import type { ReactElement } from 'react';
import { type MessageDescriptor, useIntl } from 'react-intl';

type Props = {
  errorI18nKey?: MessageDescriptor['id'];
  children: ReactElement;
};

// displays an error tooltip if the errorI18nKey prop is defined
// destined to have an input element as child
export const InputErrorTooltip = ({ errorI18nKey, children }: Props) => {
  const { formatMessage } = useIntl();
  if (isNotDefined(errorI18nKey)) {
    return children;
  }
  return (
    <Tooltip contents={formatMessage({ id: errorI18nKey })} position="top" color="danger">
      {children}
    </Tooltip>
  );
};
